import {
    Box,
    Container,
    Group
} from "@mantine/core";
import {IndexPage as MarketingPage} from "../../../marketing/pages/IndexPage";
import {ReactNode} from "react";
import classes from "../../sign-in/components/SignInPageGrid.module.css";

export const ResetPasswordPageGrid = ({children}: { children: ReactNode }) => {
    return (
        <Group className={classes.root}>
            <Box className={classes.forms}>
                <Container px={'15%'}>
                    {children}
                </Container>
            </Box>

            <Box className={classes.marketing}>
                <MarketingPage/>
            </Box>

        </Group>
    );

}
